// src/components/ProjectPDFViewer.js
import React from 'react';
import { PDFViewer } from '@react-pdf/renderer';
import ProjectPDF from './ProjectPDF';

function ProjectPDFViewer({ proyecto, logoUrl }) {
    return (
        <div style={{ flexGrow: 1, height: '90vh' }}>
            <PDFViewer width="100%" height="100%" style={{ border: 'none' }}>
                <ProjectPDF proyecto={proyecto} logoUrl={logoUrl} />
            </PDFViewer>
        </div>
    );
}

export default ProjectPDFViewer;